import { CALL_API } from "../../../middlewares/api";
import { fetch_borrower_depot } from "../../users/depot/actions";

export const CREATE_BORROWER_SURPLUS_WITHDRAWAL_REQUEST =
  "CREATE_BORROWER_SURPLUS_WITHDRAWAL_REQUEST";
export const CREATE_BORROWER_SURPLUS_WITHDRAWAL_SUCCESS =
  "CREATE_BORROWER_SURPLUS_WITHDRAWAL_SUCCESS";
export const CREATE_BORROWER_SURPLUS_WITHDRAWAL_ERROR =
  "CREATE_BORROWER_SURPLUS_WITHDRAWAL_ERROR";

export function borrower_surplus_withdrawal(borrowerIds) {
  const data = {
    BorrowerIds: borrowerIds,
    ThrowIfNoAccount: false,
  };
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loanstep/create-borrower-surplus-withdrawal-orders",
      method: "POST",
      authenticatedRequest: true,
      data: data,
      types: [
        CREATE_BORROWER_WITHDRAWAL_REQUEST,
        CREATE_BORROWER_SURPLUS_WITHDRAWAL_SUCCESS,
        CREATE_BORROWER_WITHDRAWAL_ERROR,
      ],
    },
  };
}

export const CREATE_BORROWER_WITHDRAWAL_REQUEST =
  "CREATE_BORROWER_WITHDRAWAL_REQUEST";
export const CREATE_BORROWER_WITHDRAWAL_SUCCESS =
  "CREATE_BORROWER_WITHDRAWAL_SUCCESS";
export const CREATE_BORROWER_WITHDRAWAL_ERROR =
  "CREATE_BORROWER_WITHDRAWAL_ERROR";

export const create_borrower_withdrawal = (
  borrowerId,
  accountId,
  amount,
  notes,
) => {
  const data = {
    BorrowerId: borrowerId,
    BankAccountId: accountId,
    Amount: amount,
    Notes: notes,
  };

  return {
    [CALL_API]: {
      endpoint: "/api/admin/loanstep/create-borrower-withdrawal-order",
      method: "POST",
      authenticatedRequest: true,
      data: data,
      types: [
        CREATE_BORROWER_WITHDRAWAL_REQUEST,
        { method: create_borrower_withdrawal_success.bind(this, borrowerId) },
        CREATE_BORROWER_WITHDRAWAL_ERROR,
      ],
    },
  };
};

const create_borrower_withdrawal_success = (borrowerId, response) => {
  return (dispatch) => {
    dispatch({ type: CREATE_BORROWER_WITHDRAWAL_SUCCESS, response });
    dispatch(fetch_borrower_withdrawals(borrowerId));
  };
};

export const FETCH_BORROWER_WITHDRAWALS_REQUEST =
  "FETCH_BORROWER_WITHDRAWALS_REQUEST";
export const FETCH_BORROWER_WITHDRAWALS_SUCCESS =
  "FETCH_BORROWER_WITHDRAWALS_SUCCESS";
export const FETCH_BORROWER_WITHDRAWALS_ERROR =
  "FETCH_BORROWER_WITHDRAWALS_ERROR";

export const fetch_borrower_withdrawals = (borrowerId) => {
  return {
    [CALL_API]: {
      endpoint:
        "/api/admin/loanstep/get-borrower-withdrawal-orders?borrowerId=" +
        borrowerId,
      method: "GET",
      authenticatedRequest: true,
      types: [
        FETCH_BORROWER_WITHDRAWALS_REQUEST,
        FETCH_BORROWER_WITHDRAWALS_SUCCESS,
        FETCH_BORROWER_WITHDRAWALS_ERROR,
      ],
    },
  };
};

export const CONFIRM_BORROWER_WITHDRAWAL_REQUEST =
  "CONFIRM_BORROWER_WITHDRAWAL_REQUEST";
export const CONFIRM_BORROWER_WITHDRAWAL_SUCCESS =
  "CONFIRM_BORROWER_WITHDRAWAL_SUCCESS";
export const CONFIRM_BORROWER_WITHDRAWAL_ERROR =
  "CONFIRM_BORROWER_WITHDRAWAL_ERROR";

export const confirm_borrower_withdrawal = (
  borrowerId,
  depotId,
  withdrawalId,
) => {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loanstep/confirm-borrower-withdrawal-order",
      method: "POST",
      authenticatedRequest: true,
      data: { Id: withdrawalId },
      types: [
        CREATE_BORROWER_WITHDRAWAL_REQUEST,
        {
          method: confirm_borrower_withdrawal_success.bind(
            this,
            borrowerId,
            depotId,
          ),
        },
        CREATE_BORROWER_WITHDRAWAL_ERROR,
      ],
    },
  };
};

const confirm_borrower_withdrawal_success = (borrowerId, depotId, response) => {
  return (dispatch) => {
    dispatch({ type: CONFIRM_BORROWER_WITHDRAWAL_SUCCESS, response });
    dispatch(fetch_borrower_withdrawals(borrowerId));
    dispatch(fetch_borrower_depot(borrowerId, depotId));
  };
};
